import { render } from "./ChatInputBox.vue?vue&type=template&id=7c5997dc&scoped=true"
import script from "./ChatInputBox.vue?vue&type=script&lang=js"
export * from "./ChatInputBox.vue?vue&type=script&lang=js"

import "./ChatInputBox.vue?vue&type=style&index=0&id=7c5997dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5997dc"]])

export default __exports__